// Objects render order
export const RENDER_ORDER_IMAGE_VIEWER = -1;
export const RENDER_ORDER_DEFAULT = 0;
export const RENDER_ORDER_POLYGON = RENDER_ORDER_DEFAULT;
export const RENDER_ORDER_MARKER = 1;

// instanced objects can have several meshes occupying a render order range
export const RENDER_ORDER_POINT_CLOUD = 100;
export const RENDER_ORDER_IMAGE_ANCHOR = 101;
export const RENDER_ORDER_CUBOID = 102;
export const RENDER_ORDER_TRANSFORM_CONTROLS = 103;
